import { useEffect, useState } from 'react';
import { request } from '../api';
import type { SimState } from '../domain/model';

type AidList = {
  centers: { id:string; name:string; distanceKm:number; publishedUnits:number }[];
  selectedCenterId?: string;
  units: { key:string; name:string; kind:string; typeLabel:string; station:string;
    sourceUrl:string; callSignVerified:boolean; available:boolean; reason:string }[];
};
export default function MutualAidPanel({state,incidentId,enabled,onState}: {
  state:SimState; incidentId?:string; enabled:boolean; onState:(s:SimState)=>void;
}) {
  const [open,setOpen] = useState(false), [center,setCenter] = useState('');
  const [data,setData] = useState<AidList>(), [keys,setKeys] = useState<string[]>([]);
  const [busy,setBusy] = useState(false), [message,setMessage] = useState('');
  const [refresh,setRefresh] = useState(0);
  useEffect(() => {
    if (!open) return;
    let cancelled = false;
    setData(undefined); setKeys([]); setMessage('');
    request<AidList>('mutual-aid' + (center ? '?centerId=' + encodeURIComponent(center) : ''))
      .then(result => { if (!cancelled) setData(result); })
      .catch(error => { if (!cancelled) setMessage(error.message); });
    return () => { cancelled = true; };
  }, [open,center,state.area.controlCenterId,refresh]);
  if (!state.area.controlCenterId) return null;
  return <section className="mutual-aid-panel">
    <button className="button" type="button" aria-expanded={open} onClick={()=>setOpen(!open)}>
      Überlandhilfe anfordern
    </button>
    {open && <div className="dialog-stack">
      <p className="muted small">Leitstellen im Umkreis bis 150 km. Veröffentlichte Fahrzeuge, Verfügbarkeit im Spiel simuliert.
        Die Anforderung gilt für diesen Einsatz. Fremdkräfte fahren von ihrer Heimatwache an.</p>
      {data && <>
        <label>Unterstützende Leitstelle<select aria-label="Unterstützende Leitstelle"
          value={data.selectedCenterId ?? ''} disabled={busy} onChange={e=>setCenter(e.target.value)}>
          {data.centers.map(c=><option key={c.id} value={c.id}>
            {c.name} · {c.publishedUnits} belegte Kräfte
          </option>)}
        </select></label>
        <div className="aid-unit-list">
          {data.units.map(u=><label key={u.key} className="aid-unit">
            <input type="checkbox" checked={keys.includes(u.key)} disabled={!u.available || busy}
              onChange={e=>setKeys(e.target.checked ? [...keys,u.key].slice(0,30) : keys.filter(k=>k!==u.key))}/>
            <span><strong>{u.name}</strong><small>{u.station} · {u.typeLabel}</small>
              <small>{u.reason}{!u.callSignVerified ? ' · Funkrufname offen' : ''}</small></span>
            <a href={u.sourceUrl} target="_blank" rel="noreferrer" onClick={e=>e.stopPropagation()}>Quelle ↗</a>
          </label>)}
          {!data.units.length && <p>Für diese Leitstelle liegen noch keine passenden Fahrzeugbelege vor.</p>}
        </div>
        <div className="form-columns">
          <button className="button primary" disabled={busy || !enabled || !incidentId || !keys.length}
            onClick={async()=>{
              setBusy(true); setMessage('');
              try {
                const result = await request<{state:SimState}>('mutual-aid', {
                  centerId:data.selectedCenterId,incidentId,keys,
                });
                onState(result.state);setKeys([]);setOpen(false);
              } catch(error) {setMessage((error as Error).message);}
              finally {setBusy(false);}
            }}>{busy ? 'Anforderung läuft …' : keys.length + ' Kräfte anfordern'}</button>
          <button className="button" disabled={busy} onClick={()=>setRefresh(refresh+1)}>Verfügbarkeit aktualisieren</button>
        </div>
        {!incidentId && <p className="muted small">Zuerst einen laufenden Einsatz auswählen.</p>}
      </>}
      {!data && !message && <p>Bestände werden geprüft …</p>}
      {message && <p role="alert">{message}</p>}
    </div>}
  </section>;
}
